/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CloseInputs */

const es_nav_close = /** @type {(inputs: Nav_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const gl_nav_close = /** @type {(inputs: Nav_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pechar`)
};

const en_nav_close = /** @type {(inputs: Nav_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Nav_CloseInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_close = /** @type {((inputs?: Nav_CloseInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CloseInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_close(inputs)
	if (locale === "en") return en_nav_close(inputs)
	return es_nav_close(inputs)
});